import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasTv = createSelector(selectJsonQuery, jsonQuery => getTermValue('tv')(jsonQuery));
